// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","socials":"Footer_socials__ZF4eW","socialIcon":"Footer_socialIcon__oqn34","attribution":"Footer_attribution__bkFtl"};